<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.providerData") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #072e68">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h4>
            {{ $t("PLACEHOLDERS.order_data") }}
          </h4>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('TABLES.Orders.orderNumber')"
            v-model.trim="data.id"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('TABLES.Orders.orderDate')"
            v-model.trim="data.createdAt"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('TABLES.Orders.orderStatus')"
            v-model.trim="data.status_trans"
            disabled
          />
          <hr class="w-75 mx-auto my-5" />
          <h4>{{ $t("PLACEHOLDERS.client_data") }}</h4>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model.trim="data.clientName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientPhone')"
            v-model.trim="data.clientPhone"
            disabled
          />
          <hr class="w-75 mx-auto my-5" />
          <h4>{{ $t("PLACEHOLDERS.providerData") }}</h4>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('TABLES.Orders.storeName')"
            v-model.trim="data.storeName"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.main_category_name')"
            v-model="data.mainCategory"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sub_category_name')"
            v-model="data.subCategory"
            disabled
          />
          <base-input
            col="5"
            type="text"
            :placeholder="$t('SIDENAV.OffersManagement.providerMobile')"
            v-model.trim="data.provider_phone"
            disabled
          />
          <base-input
            col="7"
            type="text"
            :placeholder="$t('PLACEHOLDERS.providerAddress')"
            v-model.trim="data.address"
            disabled
          />
          <hr class="w-75 mx-auto my-5" />
          <div>
            <h4 v-if="this.data.driverName">
              {{ $t("PLACEHOLDERS.driver_data") }}
            </h4>
            <div
              class="d-flex flex-wrap justify-content-start align-items-center"
            >
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.driverName')"
                v-model.trim="data.driverName"
                disabled
                v-if="this.data.driverName"
              />
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.receiving_method')"
                v-model.trim="data.receiving_method"
                disabled
              />
              <a
                :href="'tel:' + data.driverPhone"
                class="call-button"
                v-if="this.data.driverPhone"
                style="color: #072e68; padding: 1em; font-size: medium"
              >
                📞
                {{
                  $t("PLACEHOLDERS.contactDriver") + " : " + data.driverPhone
                }}
              </a>
            </div>
          </div>
          <hr class="w-75 mx-auto my-5" />

          <h4 v-if="this.data.receiving_methodKey === 'delivery'">
            {{ $t("PLACEHOLDERS.order_address") }}
          </h4>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area')"
            v-model.trim="data.area"
            disabled
            v-if="this.data.receiving_methodKey === 'delivery'"
          />
          <!-- v-if="this.data.area" -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            disabled
            v-if="this.data.receiving_methodKey === 'delivery'"
          />
          <!-- v-if="this.data.city" -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district"
            disabled
            v-if="this.data.receiving_methodKey === 'delivery'"
          />
          <!-- v-if="this.data.district" -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.detailsAddress')"
            v-model.trim="data.detailsAddress"
            disabled
            v-if="this.data.receiving_methodKey === 'delivery'"
          />
          <div
            class="map_wrapper"
            v-if="this.data.receiving_methodKey === 'delivery'"
          >
            <GmapMap
              :center="{
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng),
              }"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="false"
                :draggable="false"
                @click="center = m.position"
              />
            </GmapMap>
          </div>
          <hr class="w-75 mx-auto my-5" />
          <div
            style="
              display: flex;
              flex-direction: column;
              flex-wrap: wrap;
              margin-top: 20px;
            "
          >
            <div
              style="display: flex; flex-wrap: wrap"
              v-for="product in data.products"
              :key="product.id"
            >
              <h4 v-if="product">
                {{ $t("PLACEHOLDERS.required_products_and_offers") }}
              </h4>

              <base-image-upload-input
                col="12"
                identifier="image"
                :preSelectedImage="product.file_path"
                :placeholder="$t('PRODUCTS.productImage')"
                disabled
              />
              <!-- @selectImage="selectImage" -->
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PRODUCTS.productName')"
                v-model="product.name"
                disabled
              />

              <base-input
                col="3"
                type="text"
                :placeholder="$t('PRODUCTS.productSize')"
                v-model="product.size_name"
                disabled
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PRODUCTS.productPrice')"
                v-model="product.price"
                disabled
                v-if="!Ishasoffer"
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PRODUCTS.productPriceOffer')"
                v-model="product.price"
                disabled
                v-else
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('PRODUCTS.productQuantity')"
                v-model="product.quantity"
                disabled
              />
            </div>
          </div>
          <hr class="w-75 mx-auto my-5" v-if="data.additions.length > 0" />
          <div style="display: flex; flex-direction: column; flex-wrap: wrap">
            <div
              v-for="addition in data.additions"
              :key="addition.id"
              style="display: flex; flex-wrap: wrap"
            >
              <h4 v-if="addition">{{ $t("PLACEHOLDERS.additions") }}</h4>
              <base-image-upload-input
                col="12"
                identifier="image"
                :preSelectedImage="addition.file_path"
                :placeholder="$t('ADDITIONS.additionImage')"
                @selectImage="selectImage"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('ADDITIONS.additionName')"
                v-model="addition.name"
                disabled
              />
              <base-input
                col="6"
                type="number"
                :placeholder="$t('ADDITIONS.additionPrice')"
                v-model="addition.price"
                disabled
              />
            </div>
          </div>
          <hr class="w-75 mx-auto my-5" />
          <h4>
            {{ $t("PLACEHOLDERS.payment_data") }}
          </h4>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model.trim="data.payment_method"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.(VAT excloading (Total')"
            v-model.trim="data.Total_excloading_VAT"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.Delivery Charge')"
            v-model.trim="data.deliveryCharge"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.VAT')"
            v-model.trim="data.VAT"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_with_tax')"
            v-model.trim="data.total_with_tax"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.driver_profit')"
            v-model.trim="data.driver_profit"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.all_profit_driver')"
            v-model.trim="data.all_profit_driver"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_profit')"
            v-model.trim="data.provider_profit"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.all_profit_provider')"
            v-model.trim="data.all_profit_provider"
            disabled
          />
          <!-- <a
            :href="data.filePdf"
            target="_blank"
            style="color: blue; padding: 1em; border: 1px solid black"
          >
            {{ $t("PLACEHOLDERS.electronic_tax_invoice") }}</a
          > -->

          <!-- End:: count_stores Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
// import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "ShowOrders",
  // components: {
  //   UploadsPhotos,
  // },
  computed: {
    filteredOrderServices() {
      return this.data.orderServices
        ? this.data.orderServices.filter((service) => service)
        : [];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiving_methodKey: null,
        receiving_method: null,
        total_with_tax: null,
        driver_profit: null,
        provider_profit: null,
        all_profit_provider: null,
        all_profit_driver: null,
        products: [],
        additions: [],
        address: null,
        storeName: null,
        driverPhone: null,
        driverName: null,
        subCategory: null,
        mainCategory: null,
        order_additions: null,
        filePdf: null,
        deliveryCharge: null,
        payment_method: null,
        Total_excloading_VAT: null,
        VAT: null,
        service_price: null,
        additions_price: null,
        driver1_app_amount: null,
        driver2_app_amount: null,
        driver1_amount: null,
        driver2_amount: null,
        provider_app_amount: null,

        provider_amount: null,
        estimate_time: null,

        pickup_date: null,
        delivery_date: null,
        order_type: null,
        order_type_trans: null,
        orderServices: [],
        changeOrderStatus: null,
        secondPhoneDriver: null,
        secondDriverName: null,
        firstPhoneDriver: null,
        createdAt: null,
        firstDriverName: null,
        clientName: null,
        clientPhone: null,
        status: null,
        provider_phone: null,
        area: null,
        id: null,
        image: null,
        detailsAddress: null,
        provider_name: null,
        laundry_name: null,
        logo: null,
        shop_name: null,
        vendor_name: null,
        phone: null,
        email: null,
        descAr: null,
        descFr: null,
        storeCat: null,
        commercial_register_image: null,
        preparation_time: null,
        work_hours: null,
        state: null,
        city: null,
        district: null,
        street: null,
        twoer: true,
        status_trans: null,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
        work_hours: [],
      },
      additionalImages: [],
      imgUrls: [],
      markers: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    // getDay(id) {
    //   if (id == 1) {
    //     return this.$t("PLACEHOLDERS.1");
    //   }
    //   if (id == 2) {
    //     return this.$t("PLACEHOLDERS.2");
    //   }
    //   if (id == 3) {
    //     return this.$t("PLACEHOLDERS.3");
    //   }
    //   if (id == 4) {
    //     return this.$t("PLACEHOLDERS.4");
    //   }
    //   if (id == 5) {
    //     return this.$t("PLACEHOLDERS.5");
    //   }
    //   if (id == 6) {
    //     return this.$t("PLACEHOLDERS.6");
    //   }
    //   if (id == 7) {
    //     return this.$t("PLACEHOLDERS.7");
    //   }
    // },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        console.log("res", res);

        // Start:: Set Data
        this.data.id = res.data.data.Order?.id;
        this.data.status_trans = res.data.data?.Order.order_status_translated;
        this.data.createdAt = res.data.data.Order?.date;
        this.data.clientName = res.data.data.Order?.user?.name;
        this.data.clientPhone = res.data.data.Order?.user?.mobile;
        this.data.storeName = res.data.data.Order?.provider?.store_name;
        this.data.provider_phone = res.data.data.Order?.provider?.mobile;
        this.data.driverName = res.data.data.Order.driver?.name;
        this.data.driverPhone = res.data.data.Order.driver?.mobile;
        this.data.receiving_method =
          res.data.data.Order?.receiving_method_translated;
        this.data.receiving_methodKey = res.data.data.Order?.receiving_method;
        this.data.products = res.data.data.Order?.products;
        this.data.mainCategory = res.data.data.Order?.provider?.section;
        this.data.subCategory = res.data.data.Order?.provider?.sub_section;

        this.data.address = res.data.data.Order?.provider.address;

        // this.markers = [
        //   {
        //     id: 1,
        //     position: {
        //       lat: parseFloat(res.data.data.Order.address.latitude),
        //       lng: parseFloat(res.data.data.address.longitude),
        //     },
        //   },
        // ];

        this.data.lat = res.data.data.Order?.address?.latitude;
        this.data.lng = res.data.data.Order?.address?.longitude;
        this.data.area = res.data.data.Order?.address?.region_name;
        this.data.city = res.data.data.Order?.address?.state_name;
        this.data.district = res.data.data.Order?.address?.district_name;
        this.data.detailsAddress =
          res.data.data.Order?.address?.address_details;

        this.data.additions = res.data.data.Order?.additions;
        this.data.Total_excloading_VAT =
          res.data.data.Order?.summary?.total_products;
        this.data.deliveryCharge =
          res.data.data.Order?.summary?.shipping_amount;
        this.data.VAT = res.data.data.Order?.summary?.tax_amount;
        this.data.total_with_tax = res.data.data.Order?.summary?.total;
        this.data.payment_method =
          res.data.data.Order?.summary?.payment_method_translated;

        this.data.driver_profit =
          res.data.data.Order?.summary?.app_commission_from_driver;
        this.data.all_profit_driver =
          res.data.data.Order?.summary?.driver_profit;
        this.data.provider_profit =
          res.data.data.Order?.summary?.app_commission_from_provider;
        this.data.all_profit_provider =
          res.data.data.Order?.summary?.provider_profit;

        console.log("orders", this.data.orderServices);
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
